import JassEventId from './eventid';

/**
 * type unitevent
 */
export default class JassUnitEvent extends JassEventId {}
